import React from 'react';
import { LoadingButton } from '@mui/lab';
import { COLORS, SIZES, Typography } from '@fupa/fupa-uikit';
import { Container, Information } from 'app/components/match/matchLive/LivetickerCommon';
import styled from 'styled-components';
import { styled as muiStyled } from '@mui/material/styles';
import LoginHint from 'app/components/match/LoginHint';
const AssistiveText = styled.div.withConfig({
  componentId: "sc-1flzjim-0"
})(["text-align:center;min-height:", ";margin:", " 0;"], SIZES['20'], SIZES['8']);
const SecondaryButton = muiStyled(LoadingButton)({
  '&, &:hover, &:active, &:focus': {
    backgroundColor: COLORS.lightestGrey,
    color: COLORS.fupaSecondary
  }
});
const LivetickerAction = _ref => {
  let {
    buttonType,
    descriptiveText,
    error,
    isLoading,
    label,
    onClick
  } = _ref;
  const button = buttonType === 'primary' ? /*#__PURE__*/React.createElement(LoadingButton, {
    onClick: onClick,
    loading: isLoading,
    variant: "contained",
    color: "secondary"
  }, label) : /*#__PURE__*/React.createElement(SecondaryButton, {
    onClick: onClick,
    loading: isLoading,
    variant: "contained"
  }, label);
  const errorText = (error === null || error === void 0 ? void 0 : error.code) === 401 ? /*#__PURE__*/React.createElement("span", null, error === null || error === void 0 ? void 0 : error.message, " ", error !== null && error !== void 0 && error.code ? /*#__PURE__*/React.createElement(LoginHint, null) : null) : error === null || error === void 0 ? void 0 : error.message;
  return /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-component": "LivetickerAction",
    "data-sentry-source-file": "LivetickerAction.tsx"
  }, /*#__PURE__*/React.createElement(Information, {
    "data-sentry-element": "Information",
    "data-sentry-source-file": "LivetickerAction.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "LivetickerAction.tsx"
  }, descriptiveText)), button, /*#__PURE__*/React.createElement(AssistiveText, {
    "data-sentry-element": "AssistiveText",
    "data-sentry-source-file": "LivetickerAction.tsx"
  }, errorText ? /*#__PURE__*/React.createElement(Typography, {
    variant: "caption-error"
  }, errorText) : null));
};
export default LivetickerAction;